module.exports = __webpack_public_path__ + "img/Baby.69d4404b.png";